import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-card-module',
  templateUrl: './card-module.component.html',
  styleUrls: ['./card-module.component.scss']
})
export class CardModuleComponent implements OnInit {
  @Input() module: any;
  @Input() tree?: any; 

  constructor(
    private router: Router,
  ) { }

  ngOnInit(): void {
    console.log("Data recibida:", this.module);
  }

  onCardClick(module: any): void {
    console.log('Clic en módulo:', module);
    this.router.navigate(['/ruta', module.codigo_modulo]);
  }

  capitalize(text: string): string {
    if (!text) return '';
    const lower = text.toLowerCase();
    return lower.charAt(0).toUpperCase() + lower.slice(1);
  }
}
